import { useEffect, useState } from "react";
import styled from "styled-components";
import { useCookies } from "react-cookie";
import { motion, AnimatePresence } from "framer-motion";
import Icons from "../assets/icons";
import { useLocation } from "react-router-dom";

const PopupStyle = styled.section`
  font-size: 12px;
  display: flex;
  z-index: 5;
  position: relative;
  height: 0;
  justify-content: space-between;
  margin-top: 40px;
  .container {
    transition: 0.3s;
    display: flex;
    flex-wrap: wrap;
    max-width: 646px;
    width: 646px;
    justify-content: space-between;
    min-height: 225px;
    height: fit-content;
    margin: 40px 5px 20px 20px;
    overflow-y: auto;
    align-content: start;
    article {
      height: 225px;
      width: 320px;
      min-width: 250px;
    }
  }
  article {
    z-index: 1;
    position: relative;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    background: #ffffffee;
    max-width: 360px;
    width: 100%;
    overflow: auto;
    &.article2 {
      margin: 40px 20px 20px 5px;
      height: 360px;
      .contents-list {
        .button-location {
          position: absolute;
          top: 0;
          right: 0px;
          background-color: unset;
          .button-area {
            .button-box.style4 {
              background: #dddddd99;
              :hover {
                background: unset;
                .button {
                  background: #fff;
                }
              }
            }
          }
        }
        .popup-contents {
          display: flex;
          flex-direction: column;
          padding: unset;
          overflow: auto;
          h1 {
            min-height: 40px;
            margin-bottom: 5px;
          }
          ul {
            overflow: auto;
            max-height: calc(100vh - 100px);
            height: 100%;
            .mainPopupImage {
              width: 100%;
              aspect-ratio: 1/1;
              background-size: 100%;
              margin: unset;
            }
          }
          .recruit-link-box {
            a {
              .recruit-link-guide {
                transition: 0.3s;
                position: fixed;
                top: 10px;
                left: 0px;
                opacity: 0;
                background-color: #ffffffee;
                padding: 2px 8px;
                font-weight: bold;
                border-radius: 5px;
                box-shadow: 0 0 5px 0px #00000033;
              }
              :hover .recruit-link-guide {
                opacity: 1;
                left: 10px;
              }
            }
          }
        }
      }
    }
    &.article3 {
      .contents-list {
        .button-location {
          background-color: #4acbd6;
          .button-area {
            .button-box.style4 {
              :hover {
                .button {
                  background: #4acbd6;
                }
              }
            }
          }
        }
        .popup-contents {
          h1 {
            align-items: end;
            svg {
              margin: auto 10px auto 0;
            }
          }
          ul {
            li {
              .popup-title {
                background-color: #4acbd6;
              }
            }
          }
        }
      }
    }
    &.articleFraud {
      /* 이미지 원본 비율(1000x1500 = 2:3)에 맞춘 팝업 크기 (1.5배) */
      width: 420px;
      max-width: 420px;
      height: 630px;
      min-width: unset;
      .contents-list {
        height: 100%;
        .popup-contents {
          flex: 1;
          padding: unset;
          overflow: hidden;
          .mainPopupImage {
            display: flex;
            width: 100%;
            height: 100%;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
    &.articleAi {
      margin: auto;
      width: unset;
      max-width: unset;
      .contents-list {
        .button-location {
          background-color: #880194;
          .button-area {
            .button-box.style4 {
              :hover {
                .button {
                  background: #880194;
                }
              }
            }
          }
        }
        .popup-contents {
          padding: 0px;
          height: 80vh;
          aspect-ratio: 1;
          .mainPopupImage {
            display: flex;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            height: 100%;
          }
          .recruit-link-box {
            a {
              .recruit-link-guide {
                transition: 0.3s;
                position: fixed;
                top: 10px;
                left: 0px;
                opacity: 0;
                background-color: #ffffffee;
                padding: 2px 8px;
                font-weight: bold;
                border-radius: 5px;
                box-shadow: 0 0 5px 0px #00000033;
              }
              :hover .recruit-link-guide {
                opacity: 1;
                left: 10px;
              }
            }
          }
          h1 {
            align-items: end;
            svg {
              margin: auto 10px auto 0;
            }
          }
          ul {
            li {
              .popup-title {
                background-color: #880194;
              }
            }
          }
        }
      }
    }
    .contents-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .button-location {
        display: flex;
        background-color: #6fbe4b;
        .button-area {
          margin-left: auto;
          min-width: 30px;
          min-height: 30px;
          .button-box.style4 {
            width: 100%;
            height: 100%;
            transition: 0.3s;
            position: relative;
            .button {
              transition: 0.3s;
              position: absolute;
              width: 20px;
              height: 2px;
              background: #fff;
              top: 14.5px;
              transform: rotate(45deg);
              left: 5px;
            }
            .button-one {
              transform: rotate(-45deg);
            }
            :hover {
              background: #ffffff;
              .button {
                background: #6fbe4b;
              }
            }
          }
        }
      }
      .popup-contents {
        height: 100%;
        padding: 10px 10px 0px;
        h1 {
          font-size: 20px;
          text-align: center;
          margin: 0px 0 20px;
          display: flex;
          justify-content: center;
          svg {
            display: inline-block;
            margin: auto 4px auto 0;
          }
        }
        .popup-logo {
          display: flex;
          a {
            display: flex;
          }
        }
        ul {
          li {
            margin: 6px 0;
            p {
              font-size: 14px;
              :nth-of-type(2) {
                margin-left: 8px;
              }
            }
            .popup-title {
              width: 3px;
              height: 1em;
              display: inline-block;
              margin: auto 5px -2px 0px;
              background-color: #6fbe4b;
            }
          }
        }
      }
      .check-area {
        padding: 0 10px 5px 10px;
        display: flex;
        flex-direction: row;
        align-self: center;
        flex-wrap: wrap;
        span {
          display: flex;
          input {
            margin-right: 5px;
          }
          :first-child {
            margin-right: 20px;
          }
        }
      }
      .tell-area {
        width: fit-content;
        font-size: 0;
        display: inline-flex;
        margin: 5px 4px 0 0;
        aspect-ratio: 1/1;
        vertical-align: bottom;
        svg {
          width: 20px;
          height: 100%;
          aspect-ratio: 1/1;
        }
      }
    }
  }
  .shake-action {
    animation: shake 1s alternate ease-in-out infinite;
  }
  .shake-action-strong {
    animation: shakeStrong 1s alternate ease-in-out infinite;
  }
  @keyframes shake {
    0% {
      transform: rotate(0deg);
    }
    5% {
      transform: rotate(3deg);
    }
    10% {
      transform: rotate(-3deg);
    }
    15% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes shakeStrong {
    0% {
      transform: rotate(0deg);
    }
    5% {
      transform: rotate(10deg);
    }
    10% {
      transform: rotate(-10deg);
    }
    15% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @media (max-width: 768px) {
    position: fixed;
    display: unset;
    justify-content: unset;
    width: 95%;
    min-width: unset;
    height: 125px;
    margin: 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
    overflow: hidden;
    bottom: 10px;
    transition: 0.3s;
    &.aiStyle {
      position: unset;
      display: flex;
      justify-content: unset;
      width: unset !important;
      min-width: unset;
      height: unset;
      margin: auto;
      left: unset;
      transform: unset;
      overflow: unset;
      bottom: unset;
      height: 100%;
    }
    .isMobile {
      display: none !important;
    }
    .container {
      position: relative;
      margin: auto;
      height: 100%;
      width: 100%;
      max-width: 600px;
      max-height: unset;
      min-height: unset;
      overflow: hidden;
      article {
        height: 100%;
        width: 50%;
        min-width: unset;
      }
    }
    article {
      position: absolute;
      transition: 0.3s;
      height: 100%;
      width: calc(50% - 3px);
      min-height: unset !important;
      max-height: unset !important;
      overflow: hidden;
      left: 0%;
      &.article1 {
      }
      &.article2 {
        display: none;
      }
      &.article3 {
        .contents-list {
          .popup-contents {
            ul {
              li {
                p {
                  :last-child {
                  }
                }
              }
            }
          }
        }
      }
      &.articleAi {
        width: unset;
        max-width: unset;
        position: unset;
        height: unset;
        width: unset !important;
        min-height: unset !important;
        max-height: unset !important;
        overflow: unset;
        .contents-list {
          .popup-contents {
            height: 90vw;

            ul {
              li {
                p {
                  :last-child {
                  }
                }
              }
            }
          }
        }
      }
      :nth-of-type(2) {
        margin-left: 6px;
        left: 50%;
      }
      :last-child {
        width: 100%;
      }
      & + article {
        width: calc(50% - 3px) !important;
      }
      .contents-list {
        .button-location {
          .button-area {
            min-width: 20px;
            min-height: 20px;
            .button-box.style4 {
              .button {
                width: 10px;
                height: 1.5px;
                top: 10px;
              }
            }
          }
        }
        .popup-contents {
          padding: 0 5px;
          h1 {
            font-size: 14px;
            margin: 5px 0;
            svg {
              display: none;
            }
          }
          .popup-logo {
            display: flex;
            a {
              display: flex;
            }
          }
          ul {
            li {
              display: flex;
              flex-wrap: wrap;
              margin: 12px 0;
              p {
                font-size: 10px;
                :nth-of-type(2) {
                  margin-left: unset;
                  margin-top: unset;
                }
              }
              .popup-title {
                width: 3px;
                height: 1.4em;
                display: inline-block;
                margin: auto 5px -2px 0px;
                background-color: #6fbe4b;
              }
            }
          }
        }
        .check-area {
          padding: 3px;
          font-size: 10px;
          span {
            padding: 0;
            margin-bottom: unset;
            input {
              margin-right: 3px;
              width: 1em;
              align-self: end;
            }
          }
        }
        .tell-area {
          margin: 0 4px 0 0;
          vertical-align: middle;
          svg {
            width: 16px;
            height: 100%;
            aspect-ratio: 1/1;
          }
        }
      }
    }
  }
`;
const checkHandle = ({
  e,
  setCookies,
  removeCookie,
}: {
  e: any;
  setCookies: any;
  removeCookie: any;
}) => {
  switch (e.target.id) {
    case "seagateDayHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(1);
        setCookies("seagateDayHideCheck", true, { path: "/", expires });
      } else {
        removeCookie("seagateDayHideCheck");
      }
      break;

    case "seagateWeekHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(7);
        setCookies("seagateWeekHideCheck", true, { path: "/", expires });
        removeCookie("seagateDayHideCheck");
      } else {
        removeCookie("seagateWeekHideCheck");
      }
      break;

    // case "tplinkDayHideCheck":
    //   if (e.target.checked) {
    //     const expires = getExpiredDate(1);
    //     setCookies("tplinkDayHideCheck", true, { path: "/", expires });
    //   } else {
    //     removeCookie("tplinkDayHideCheck");
    //   }
    //   break;

    // case "tplinkWeekHideCheck":
    //   if (e.target.checked) {
    //     const expires = getExpiredDate(7);
    //     setCookies("tplinkWeekHideCheck", true, { path: "/", expires });
    //     removeCookie("tplinkDayHideCheck");
    //   } else {
    //     removeCookie("tplinkWeekHideCheck");
    //   }
    //   break;

    case "fraudDayHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(1);
        setCookies("fraudDayHideCheck", true, { path: "/", expires });
      } else {
        removeCookie("fraudDayHideCheck");
      }
      break;

    case "fraudWeekHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(7);
        setCookies("fraudWeekHideCheck", true, { path: "/", expires });
        removeCookie("fraudDayHideCheck");
      } else {
        removeCookie("fraudWeekHideCheck");
      }
      break;

    case "aiDayHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(1);
        setCookies("aiDayHideCheck", true, { path: "/", expires });
      } else {
        removeCookie("aiDayHideCheck");
      }
      break;

    case "aiWeekHideCheck":
      if (e.target.checked) {
        const expires = getExpiredDate(7);
        setCookies("aiWeekHideCheck", true, { path: "/", expires });
        removeCookie("aiDayHideCheck");
      } else {
        removeCookie("aiWeekHideCheck");
      }
      break;

    default:
      break;
  }
};
const PopupContents = ({
  setIsClosed,
  setCookies,
  removeCookie,
}: {
  setIsClosed: any;
  setCookies: any;
  removeCookie: any;
}) => {
  return (
    <>
      <ul className="contents-list">
        <li className="button-location">
          <div
            onClick={() => setIsClosed(true)}
            className="button-area pointer"
          >
            <div className="button-box style4">
              <p className="button button-one"></p>
              <p className="button button-two"></p>
            </div>
          </div>
        </li>
        <li className="popup-contents">
          <h1>
            <Icons.BrandSeagate width={32} height={32} />
            <span>
              씨게이트 A/S <span className="isMobile">센터 </span>안내
            </span>
          </h1>
          <ul>
            <li className="isMobile">
              <p>
                <span className="popup-title"></span>
                <b>센터위치</b>
              </p>
              <p>
                <span style={{ wordBreak: "keep-all" }}>
                  서울특별시 용산구 한강대로 273, 용산빌딩&nbsp;4층
                </span>
              </p>
            </li>
            {/* <li className="isMobile">
              <p>
                <span className="popup-title"></span>
                <b>운영시간</b>
              </p>
              <p>
                <span>평일 10시 ~ 17시 (점심시간: 12시 ~ 13시)</span>
              </p>
              <p>*주말·공휴일은 운영하지 않습니다</p>
            </li> */}
            <li>
              <p className="isMobile">
                <span className="popup-title"></span>
                <b>A/S문의</b>
              </p>
              <p style={{ wordBreak: "keep-all" }}>
                <a href="tel:02-1811-7247">
                  <b className="tell-area shake-action-strong">
                    <Icons.IconCallSeagate />
                  </b>
                  <span>1811-7247 (내선&nbsp;1번&nbsp;→&nbsp;1번)</span>
                </a>
              </p>
            </li>
          </ul>
        </li>
        <li className="check-area">
          <span onClick={() => setIsClosed(true)}>
            <input
              type="checkbox"
              id="seagateWeekHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="seagateWeekHideCheck">
              1주일간 표시하지 않기
            </label>
          </span>
          <span onClick={() => setIsClosed(true)}>
            <input
              type="checkbox"
              id="seagateDayHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="seagateDayHideCheck">
              1일간 표시하지 않기
            </label>
          </span>
        </li>
      </ul>
    </>
  );
};
const fraudPopupImage = ["main-fraud-warning.jpg"];
const PopupContentsFraud = ({
  setIsClosedFraud,
  setCookies,
  removeCookie,
}: {
  setIsClosedFraud: any;
  setCookies: any;
  removeCookie: any;
}) => {
  return (
    <>
      <ul className="contents-list">
        <li className="button-location">
          <div
            onClick={() => setIsClosedFraud(true)}
            className="button-area pointer"
          >
            <div className="button-box style4">
              <p className="button button-one"></p>
              <p className="button button-two"></p>
            </div>
          </div>
        </li>
        <li className="popup-contents">
          <a
            href="https://www.seagate.com/kr/ko/support/data-recovery-services/"
            target="_blank"
            rel="noreferrer"
            style={{ display: "flex", height: "100%", width: "100%" }}
          >
            {fraudPopupImage.map((img, idx) => (
              <span
                key={idx}
                className="mainPopupImage"
                style={{ backgroundImage: `url(/background/${img})` }}
              />
            ))}
          </a>
        </li>
        <li className="check-area">
          <span onClick={() => setIsClosedFraud(true)}>
            <input
              type="checkbox"
              id="fraudWeekHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="fraudWeekHideCheck">
              1주일간 표시하지 않기
            </label>
          </span>
          <span onClick={() => setIsClosedFraud(true)}>
            <input
              type="checkbox"
              id="fraudDayHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="fraudDayHideCheck">
              1일간 표시하지 않기
            </label>
          </span>
        </li>
      </ul>
    </>
  );
};
// const PopupContents3 = ({
//   setIsClosed3,
//   setCookies,
//   removeCookie,
// }: {
//   setIsClosed3: any;
//   setCookies: any;
//   removeCookie: any;
// }) => {
//   return (
//     <>
//       <ul className="contents-list">
//         <li className="button-location">
//           <div
//             onClick={() => setIsClosed3(true)}
//             className="button-area pointer"
//           >
//             <div className="button-box style4">
//               <p className="button button-one"></p>
//               <p className="button button-two"></p>
//             </div>
//           </div>
//         </li>
//         <li className="popup-contents">
//           <h1>
//             <Icons.BrandTpLinkNotext width={90 / 3} height={90 / 3} />
//             <span>tp-link 교환/반품 문의</span>
//           </h1>
//           <ul>
//             <li>
//               <p className="isMobile">
//                 <span className="popup-title"></span>
//                 <b>제품 교환, 반품 문의</b>
//               </p>
//               <p>
//                 <a href="tel:02-2006-6516">
//                   <b className="tell-area shake-action-strong">
//                     <Icons.IconCallTplink />
//                   </b>
//                   <span>02-2006-6516</span>
//                 </a>
//               </p>
//             </li>
//           </ul>
//         </li>
//         <li className="check-area">
//           <span onClick={() => setIsClosed3(true)}>
//             <input
//               type="checkbox"
//               id="tplinkWeekHideCheck"
//               className="pointer"
//               onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
//             />
//             <label className="pointer" htmlFor="tplinkWeekHideCheck">
//               1주일간 표시하지 않기
//             </label>
//           </span>
//           <span onClick={() => setIsClosed3(true)}>
//             <input
//               type="checkbox"
//               id="tplinkDayHideCheck"
//               className="pointer"
//               onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
//             />
//             <label className="pointer" htmlFor="tplinkDayHideCheck">
//               1일간 표시하지 않기
//             </label>
//           </span>
//         </li>
//       </ul>
//     </>
//   );
// };

const mainPopupImage = ["main-recruit.jpg"];
const PopupContents2 = ({ setIsClosed2 }: { setIsClosed2: any }) => {
  return (
    <>
      <ul className="contents-list">
        <li className="button-location">
          <div
            onClick={() => setIsClosed2(true)}
            className="button-area pointer"
          >
            <div className="button-box style4">
              <p className="button button-one"></p>
              <p className="button button-two"></p>
            </div>
          </div>
        </li>
        <li className="popup-contents">
          <ul className="recruit-link-box">
            <a href="/recruit" target="_blank">
              {mainPopupImage.map((img, idx) => {
                return (
                  <li
                    key={idx}
                    className="mainPopupImage"
                    style={{ backgroundImage: `url(background/${img})` }}
                  ></li>
                );
              })}
              <div className="recruit-link-guide shake-action">
                <p>채용 페이지로</p>
              </div>
            </a>
          </ul>
        </li>
      </ul>
    </>
  );
};

const aiPopupImage = ["main-ai.jpg"];
const PopupAi = ({
  setIsAiClosed,
  setCookies,
  removeCookie,
}: {
  setIsAiClosed: any;
  setCookies: any;
  removeCookie: any;
}) => {
  return (
    <>
      <ul className="contents-list">
        <li className="button-location">
          <div
            onClick={() => setIsAiClosed(true)}
            className="button-area pointer"
          >
            <div className="button-box style4">
              <p className="button button-one"></p>
              <p className="button button-two"></p>
            </div>
          </div>
        </li>
        <li className="popup-contents">
          {aiPopupImage.map((img, idx) => {
            return (
              <span
                key={idx}
                className="mainPopupImage"
                style={{ backgroundImage: `url(/background/${img})` }}
              />
            );
          })}
        </li>
        <li className="check-area">
          <span onClick={() => setIsAiClosed(true)}>
            <input
              type="checkbox"
              id="aiWeekHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="aiWeekHideCheck">
              1주일간 표시하지 않기
            </label>
          </span>
          <span onClick={() => setIsAiClosed(true)}>
            <input
              type="checkbox"
              id="aiDayHideCheck"
              className="pointer"
              onChange={(e) => checkHandle({ e, setCookies, removeCookie })}
            />
            <label className="pointer" htmlFor="aiDayHideCheck">
              1일간 표시하지 않기
            </label>
          </span>
        </li>
      </ul>
    </>
  );
};
const getExpiredDate = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

const Popup = () => {
  const [cookies, setCookies, removeCookie] = useCookies();
  const [isClosed, setIsClosed] = useState(
    cookies["seagateDayHideCheck"] || cookies["seagateWeekHideCheck"] || false
  );
  const [isClosed2, setIsClosed2] = useState(false);
  const [isClosed3, setIsClosed3] = useState(
    cookies["seagateWeekHideCheck"] || cookies["seagateDayHideCheck"] || false
  );
  const [isClosedFraud, setIsClosedFraud] = useState(
    cookies["fraudWeekHideCheck"] || cookies["fraudDayHideCheck"] || false
  );
  const [isAiClosed, setIsAiClosed] = useState(
    cookies["aiWeekHideCheck"] || cookies["aiDayHideCheck"] || false
  );
  const [isAllClosed, setIsAllClosed] = useState(false);

  const location = useLocation();
  const path3 = location.pathname.split("/")[3];
  useEffect(() => {
    // 씨게이트 A/S 안내·채용 배너 팝업은 현재 주석 처리로 숨겨둔 상태라
    // 사칭 안내 팝업(isClosedFraud) 하나만 닫히면 전체를 닫는다.
    if (path3 !== "ai" && isClosedFraud) {
      setIsAllClosed(true);
    } else if (path3 === "ai") {
      if (isAiClosed) {
        setIsAllClosed(true);
      }
    }
  }, [isClosedFraud, isAiClosed]);
  return (
    <>
      {(
        <AnimatePresence>
          {!isAllClosed ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                height: "calc(100vh)",
                overflow: "hidden",
                width: "calc(100vw)",
                zIndex: 3,
              }}
              onWheel={(e) => e.stopPropagation()}
            >
              <PopupStyle className={path3 === "ai" ? "aiStyle" : ""}>
                {path3 !== "ai" ? (
                  <>
                    <div className="container">
                      {/* 씨게이트 A/S 안내 팝업 임시 숨김 - 복구하려면 아래 여는/닫는 주석기호만 제거
                      <AnimatePresence>
                        {(cookies["seagateWeekHideCheck"] === undefined ||
                          cookies["seagateWeekHideCheck"] === false) &&
                          (cookies["seagateDayHideCheck"] === undefined ||
                            cookies["seagateDayHideCheck"] === false) &&
                          !isClosed && (
                            <motion.article
                              className="article1"
                              initial={{ translateY: "-80px", opacity: 0 }}
                              animate={{ translateY: "0", opacity: 1 }}
                              exit={{
                                translateY: "-80px",
                                opacity: 0,
                                minWidth: "0px",
                                height: "0px",
                                minHeight: "0px",
                                overflow: "hidden",
                              }}
                              transition={{
                                ease: "easeInOut",
                                duration: 0.5,
                              }}
                            >
                              <PopupContents
                                setCookies={setCookies}
                                removeCookie={removeCookie}
                                setIsClosed={setIsClosed}
                              />
                            </motion.article>
                          )}
                      </AnimatePresence>
                      */}
                      <AnimatePresence>
                        {(cookies["fraudWeekHideCheck"] === undefined ||
                          cookies["fraudWeekHideCheck"] === false) &&
                          (cookies["fraudDayHideCheck"] === undefined ||
                            cookies["fraudDayHideCheck"] === false) &&
                          !isClosedFraud && (
                            <motion.article
                              className="articleFraud"
                              initial={{ translateY: "-80px", opacity: 0 }}
                              animate={{ translateY: "0", opacity: 1 }}
                              exit={{
                                translateY: "-80px",
                                opacity: 0,
                                minWidth: "0px",
                                height: "0px",
                                minHeight: "0px",
                                overflow: "hidden",
                              }}
                              transition={{
                                ease: "easeInOut",
                                duration: 0.5,
                              }}
                            >
                              <PopupContentsFraud
                                setCookies={setCookies}
                                removeCookie={removeCookie}
                                setIsClosedFraud={setIsClosedFraud}
                              />
                            </motion.article>
                          )}
                      </AnimatePresence>
                      {/* <AnimatePresence>
                        {(cookies["tplinkWeekHideCheck"] === undefined ||
                          cookies["tplinkWeekHideCheck"] === false) &&
                          (cookies["tplinkDayHideCheck"] === undefined ||
                            cookies["tplinkDayHideCheck"] === false) &&
                          !isClosed3 && (
                            <motion.article
                              className="article3"
                              initial={{ translateY: "-80px", opacity: 0 }}
                              animate={{ translateY: "0", opacity: 1 }}
                              exit={{
                                translateY: "-80px",
                                opacity: 0,
                                minWidth: "0px",
                                height: "0px",
                                minHeight: "0px",
                                overflow: "hidden",
                              }}
                              transition={{
                                ease: "easeInOut",
                                duration: 0.5,
                              }}
                            >
                              <PopupContents3
                                setCookies={setCookies}
                                removeCookie={removeCookie}
                                setIsClosed3={setIsClosed3}
                              />
                            </motion.article>
                          )}
                      </AnimatePresence> */}
                    </div>
                    {/* 채용 배너 팝업 임시 숨김 - 복구하려면 아래 여는/닫는 주석기호만 제거
                    <AnimatePresence>
                      {!isClosed2 && (
                        <motion.article
                          className="article2"
                          initial={{ translateY: "-80px", opacity: 0 }}
                          animate={{ translateY: "0", opacity: 1 }}
                          exit={{
                            translateY: "-80px",
                            opacity: 0,
                            overflow: "hidden",
                          }}
                          transition={{
                            ease: "easeInOut",
                            duration: 0.5,
                          }}
                        >
                          <PopupContents2 setIsClosed2={setIsClosed2} />
                        </motion.article>
                      )}
                    </AnimatePresence>
                    */}
                  </>
                ) : (
                  <>
                    <AnimatePresence>
                      {(cookies["aiWeekHideCheck"] === undefined ||
                        cookies["aiWeekHideCheck"] === false) &&
                        (cookies["aiDayHideCheck"] === undefined ||
                          cookies["aiDayHideCheck"] === false) &&
                        !isAiClosed && (
                          <motion.article
                            className="articleAi"
                            initial={{ translateY: "-80px", opacity: 0 }}
                            animate={{ translateY: "0", opacity: 1 }}
                            exit={{
                              translateY: "-80px",
                              opacity: 0,
                              overflow: "hidden",
                            }}
                            transition={{
                              ease: "easeInOut",
                              duration: 0.5,
                            }}
                          >
                            {
                              <PopupAi
                                setIsAiClosed={setIsAiClosed}
                                setCookies={setCookies}
                                removeCookie={removeCookie}
                              />
                            }
                          </motion.article>
                        )}
                    </AnimatePresence>
                  </>
                )}
              </PopupStyle>
              <motion.div
                initial={{ translateY: "80px", opacity: 0 }}
                animate={{ translateY: "0", opacity: 1 }}
                exit={{
                  opacity: 0,
                  overflow: "hidden",
                }}
                onClick={() => (
                  setIsClosed(true),
                  setIsClosed2(true),
                  setIsClosed3(true),
                  setIsClosedFraud(true),
                  setIsAiClosed(true)
                )}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  zIndex: 0,
                  top: 0,
                  background: "#00000066",
                }}
              />
            </div>
          ) : (
            ""
          )}
        </AnimatePresence>
      )}
    </>
  );
};
export default Popup;
